
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    applyButton: {
        cursor: 'pointer',
        transition: 'background 0.3s, border-color 0.3s',
        position: 'relative',
        display: 'inline-block',
        textAlign: 'center',
        textDecoration: 'none',
        border: '2px solid transparent',
        borderRadius: '4px',
        width: 'auto',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '19px',
        lineHeight: '22px',
        letterSpacing: undefined,
        paddingTop: '12px',
        paddingBottom: '12px',
        color: '#484848',
        fontWeight: 700,
        paddingRight: '24px',
        paddingLeft: '24px',
        minWidth: '77.66563145999496px',
        background: '#00c8ff',
        outline: 'none'
    },
    applyButtonText: {
        transition: 'color 0.3s',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '19px',
        lineHeight: '22px',
        letterSpacing: undefined,
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#ffffff'
    },
    baseline_none: {
        borderBottom: '0px',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    cancelButton: {
        color: '#484848',
        font: 'inherit',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        textDecoration: 'none',
        appearance: 'none',
        background: 'transparent',
        border: '0px',
        cursor: 'pointer',
        margin: '0px',
        padding: '0px',
        textAlign: 'left',
        userSelect: 'auto'
    },
    checkboxInput: {
        position: 'absolute',
        width: '0px',
        opacity: 0
    },
    column: {
        paddingLeft: '8px',
        paddingRight: '8px',
        minHeight: '1px',
        position: 'relative',
        width: '100%',
        float: 'left',
        '@media (min-width: 1128px)': {
            width: '50%',
            float: 'left'
        },
        '@media (min-width: 744px)': {
            width: '50%',
            float: 'left'
        }
    },
    columnTable: {
        display: 'table-cell',
        verticalAlign: 'top',
        whiteSpace: 'normal'
    },
    containerFixed: {
        background: '#ffffff',
        bottom: '0px',
        left: '0px',
        paddingRight: '24px',
        position: 'fixed',
        width: '66%',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '100%'
        }
    },
    containerInline: {
        display: 'inline-block',
        cursor: 'pointer',
        padding: '0px'
    },
    containerTable: {
        display: 'table'
    },
    containerTableChild: {
        display: 'table-cell',
        verticalAlign: 'middle'
    },
    iconWrapper: {
        display: 'table-cell',
        verticalAlign: 'middle',
        transitionProperty: '-ms-transform,-webkit-transform,transform',
        transitionDuration: '250ms',
        transitionTimingFunction: 'ease-in-out'
    },
    inlineBlock: {
        display: 'inline-block'
    },
    panel: {
        position: 'fixed',
        top: '188px',
        left: '0px',
        zIndex: '10',
        background: '#ffffff',
        border: 'none',
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '24px',
        overflowY: 'auto',
        whiteSpace: 'normal',
        paddingTop: '48px',
        bottom: '0px',
        height: 'initial'
    },
    panel_sixty: {
        width: '66%',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '100%'
        }
    },
    textright: {
        textAlign: 'right'
    },
    visible: {
        visibility: 'visible'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/styles.js